import React from 'react';

const PrivacyPage = () => {
  return (
    <div className="bg-background text-on-surface font-body antialiased min-h-screen pt-24 pb-20">
      <main className="max-w-4xl mx-auto px-8">
        <header className="mb-16">
          <h1 className="text-4xl md:text-5xl font-extrabold tracking-tighter mb-4 font-headline">Privacy Policy</h1>
          <p className="text-on-surface-variant italic">Last updated: April 2024</p>
        </header>

        <div className="prose prose-emerald max-w-none text-on-surface-variant leading-relaxed space-y-10">
          <section>
            <h2 className="text-2xl font-bold text-on-surface mb-4">1. Information We Collect</h2>
            <p>We collect information you provide directly to us, such as when you create an account, post a review, or communicate with us. This may include your name, email address, and profile information.</p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-on-surface mb-4">2. How We Use Information</h2>
            <p>We use the information we collect to provide, maintain, and improve our services, and to communicate with you about community updates and local recommendations.</p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-on-surface mb-4">3. Data Security</h2>
            <p>We take reasonable measures to help protect information about you from loss, theft, misuse, and unauthorized access.</p>
          </section>

          <section className="bg-surface-container-low p-8 rounded-2xl border border-outline-variant/10">
            <h2 className="text-xl font-bold text-on-surface mb-4">Contact Our Privacy Team</h2>
            <p className="text-sm">If you have any questions about this Privacy Policy, please contact us at privacy@localadvisor.com</p>
          </section>
        </div>
      </main>
    </div>
  );
};

export default PrivacyPage;
